import { render, staticRenderFns } from "./ModalInsert.vue?vue&type=template&id=074bfedc&scoped=true"
import script from "./ModalInsert.vue?vue&type=script&lang=js"
export * from "./ModalInsert.vue?vue&type=script&lang=js"
import style0 from "./ModalInsert.vue?vue&type=style&index=0&id=074bfedc&prod&scoped=true&lang=css"
import style1 from "./ModalInsert.vue?vue&type=style&index=1&id=074bfedc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074bfedc",
  null
  
)

export default component.exports